import React, { FC } from 'react';
import { Container, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { energyLaptop } from 'images/us-energy-solutions';

const useStyles = makeStyles((theme: Theme) => ({
  wrapperContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: theme.spacing(10, 0),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(15, 0),
    },
  },
  title: {
    marginBottom: theme.spacing(8),
    [theme.breakpoints.down('xs')]: {
      fontSize: 30,
    },
  },
  image: {
    width: '100%',
    marginBottom: theme.spacing(5),
    [theme.breakpoints.up('md')]: {
      maxWidth: 842,
    },
  },
  text: {
    color: theme.palette.switchedColors.textGray,
  },
}));

const EnergyManagement: FC = () => {
  const classes = useStyles();

  return (
    <Container maxWidth={false} fixed>
      <Grid container justifyContent="center">
        <Grid lg={8} xs={12} item className={classes.wrapperContent}>
          <Typography variant="h1" className={classes.title}>
            An all-in-one energy management platform
          </Typography>
          <img src={energyLaptop} alt={energyLaptop} className={classes.image} />
          <Typography variant="body2" className={classes.text}>
            US Energy Solutions is one’s go-to option when it comes to energy management. Here’s the deal – whether you’re looking
            for affordable electricity or natural gas, effective LED upgrades, eco-friendly Solar Energy solutions, profitable
            Demand Response rebates, or cutting-edge Grid Optimization options, US Energy Solutions has got your back. All you
            need is to fill in the contact form and get all the answers to any of the energy-related questions you have.
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};

export default EnergyManagement;
